import React from 'react';
import { memberProgress } from './useSupportMember';
export default function MemberStatus({ status, mark, policy, locale, t, icon }) {
  if (!status?.isSupporter) return null;
  const { months, next, progress, days } = memberProgress(status, mark, policy.milestones);
  const expiry =
    days === null
      ? t('sponsor.colorNoExpiry')
      : days === 0
        ? t('sponsor.colorExpired')
        : t('sponsor.colorActiveUntil', {
            date: new Date(status.nicknameColorActiveUntil).toLocaleDateString(
              locale === 'en' ? 'en-US' : 'ko-KR',
              { year: 'numeric', month: 'numeric', day: 'numeric' },
            ),
            count: days,
          });
  return (
    <section className="pp-support-member-status" aria-label={t('sponsor.currentStatus')}>
      <div className="pp-support-status-heading">
        <h2>
          {icon}
          {t('sponsor.currentStatus')}
        </h2>
        <span>
          {t(status.tier === 'PARTNER' ? 'sponsor.rosterPartner' : 'sponsor.rosterSupporter')}
        </span>
      </div>
      <div className="pp-support-status-row">
        <span>{t('sponsor.activeTime')}</span>
        <strong>{t('sponsor.completedMonths', { count: months })}</strong>
      </div>
      <div
        className="pp-support-progress"
        role="progressbar"
        aria-label={t('sponsor.activeTime')}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
      >
        <i style={{ width: progress + '%' }} />
      </div>
      <div className="pp-support-status-row">
        <span>{t('sponsor.nextMark')}</span>
        <strong>
          {next
            ? t('sponsor.untilNextMark', {
                count: next.paidMonths,
                remaining: Math.max(1, next.paidMonths - months),
              })
            : t('sponsor.allMarksEarned')}
        </strong>
      </div>
      <div className="pp-support-status-row">
        <span>{t('sponsor.currentColorNickname')}</span>
        <strong>{expiry}</strong>
      </div>
    </section>
  );
}
